<template>
  <div class="page-title-bar page-title">
    <span>{{ pageTitle }}</span>
    <div class="right">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    pageTitle() {
      return this.title ? this.title : this.$route.meta.title
    }
  }
}
</script>

<style lang="scss" scoped>
.page-title-bar {
  height:48px;
  padding-top:5px;
  padding-bottom:12px;
  line-height:32px;
  font-size:16px;
  font-weight:bold;
  margin-bottom:15px;
  background:#fdfdfd;
  margin-left: -14px;
  margin-right: -14px;
  padding-left: 14px;
  padding-right: 14px;
  position: relative;
  > span {
    display:inline-block;
    line-height:18px;
    border-left:solid 3px #2287f0;
    padding-left:4px;
  }
  .right{float:right;}
  .right::after {
    content: '';
    clear:both;
  }
  /*button*/
  .el-button--medium {
    padding:8px 15px;
  }
}
</style>
